// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2720%27 height=%2720%27 viewBox=%270 0 20 20%27 fill=%27none%27%3E%3Cpath d=%27M8.4 10.7273L2 2H18L11.6 10.7273V18H8.4V10.7273Z%27 fill=%27%23999999%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-week-container {
  background: #f5f0f5;
  padding: 10px;
  height: min-content;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
}

.modal-buttons-wrap {
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  padding-top: 8px;
  border-top: 1px solid #808080;
}

.modal-btn {
  cursor: pointer;
  color: #fff;
  padding: 4px 14px;
  background: #4d6eaf;
  border-radius: 4px;
  font-size: 12px;
  line-height: 17px;
}

.input-container {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.form-row {
  display: flex;
  gap: 8px;
}

.form-label {
  border-bottom: 1px solid #808080;
}

.form-row:not(:last-child) {
  margin-bottom: 16px;
}

.form-block {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.form-add-btn-wrap {
  width: 16px;
  height: 16px;
  background: #345aa4;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}

.form-title {
  border-bottom: 1px solid #808080;
  padding: 8px 0;
}

.justify-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.align-center {
  display: flex;
  align-items: center;
}

.week-days-container {
  gap: 20px;
}

.error {
  border: 1px solid #d72d30;
}

/* Grid */
.grid-container {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  min-height: 170px;
  overflow: auto;
  padding-right: 10px;
  flex: 1 1 0;
}

.grid-container_single {
  min-height: 70px;
}

.grid-header,
.grid-row {
  display: grid;
  grid-template-columns: 120px 2fr 120px auto;
  gap: 10px;
  padding: 8px 0;
  align-items: center;
}

.grid-header {
  font-weight: bold;
  background-color: #f0f0f0;
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 0;
}

.grid-body {
  flex: 1;
}

.grid-row {
  border-bottom: 1px solid #eee;
}

.delete-btn {
  cursor: pointer;
  text-align: center;
}

select,
input {
  padding: 0px 10px;
  height: 30px;
  border: 1px #475867 solid;
  width: 100%;
}

#period-form {
  display: flex;
  width: 100%;
  gap: 8px;
  padding-top: 8px;
}

#period-form .row {
  height: 30px;
  display: flex;
  align-items: center;
}

.col {
  /* Общие стили для колонок */
}

.col-fixed {
  width: auto;
  margin-right: 10px;
}

.col-flexible {
  flex: 1;
}

.row {
  margin-bottom: 12px;
}

/* Filter */
.filter-container {
  position: relative;
  display: inline-block;
  font-family: Arial, sans-serif;
}

.filter-icon {
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0 2px;
  width: 16px;
  height: 16px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
}

.filter-dropdown {
  position: absolute;
  top: 100%;
  right: 0%;
  margin-top: 8px;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  padding: 12px;
  width: 200px;
  z-index: 10003000;
  display: none;
}

.filter-dropdown.show {
  display: block;
}

.filter-option {
  display: flex;
  margin-bottom: 8px;
}

.filter-option:last-child {
  margin-bottom: 0;
}

.filter-option label {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.filter-option input {
  margin-right: 8px;
  width: 16px;
}`, "",{"version":3,"sources":["webpack://./src/controls/schedulebacnet/modals/styles.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,yDAA0O;EAC1O,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb","sourcesContent":[".modal-week-container {\r\n  background: #f5f0f5;\r\n  padding: 10px;\r\n  height: min-content;\r\n  min-height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.modal-buttons-wrap {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 20px;\r\n  padding-top: 8px;\r\n  border-top: 1px solid #808080;\r\n}\r\n\r\n.modal-btn {\r\n  cursor: pointer;\r\n  color: #fff;\r\n  padding: 4px 14px;\r\n  background: #4d6eaf;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  line-height: 17px;\r\n}\r\n\r\n.input-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;\r\n}\r\n\r\n.form-row {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.form-label {\r\n  border-bottom: 1px solid #808080;\r\n}\r\n\r\n.form-row:not(:last-child) {\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.form-block {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  width: 100%;\r\n}\r\n\r\n.form-add-btn-wrap {\r\n  width: 16px;\r\n  height: 16px;\r\n  background: #345aa4;\r\n  border-radius: 3px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  color: #fff;\r\n}\r\n\r\n.form-title {\r\n  border-bottom: 1px solid #808080;\r\n  padding: 8px 0;\r\n}\r\n\r\n.justify-between {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.align-center {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.week-days-container {\r\n  gap: 20px;\r\n}\r\n\r\n.error {\r\n  border: 1px solid #d72d30;\r\n}\r\n\r\n/* Grid */\r\n.grid-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin-bottom: 16px;\r\n  min-height: 170px;\r\n  overflow: auto;\r\n  padding-right: 10px;\r\n  flex: 1 1 0;\r\n}\r\n\r\n.grid-container_single {\r\n  min-height: 70px;\r\n}\r\n\r\n.grid-header,\r\n.grid-row {\r\n  display: grid;\r\n  grid-template-columns: 120px 2fr 120px auto;\r\n  gap: 10px;\r\n  padding: 8px 0;\r\n  align-items: center;\r\n}\r\n\r\n.grid-header {\r\n  font-weight: bold;\r\n  background-color: #f0f0f0;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 1;\r\n  padding: 0;\r\n}\r\n\r\n.grid-body {\r\n  flex: 1;\r\n}\r\n\r\n.grid-row {\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.delete-btn {\r\n  cursor: pointer;\r\n  text-align: center;\r\n}\r\n\r\nselect,\r\ninput {\r\n  padding: 0px 10px;\r\n  height: 30px;\r\n  border: 1px #475867 solid;\r\n  width: 100%;\r\n}\r\n\r\n#period-form {\r\n  display: flex;\r\n  width: 100%;\r\n  gap: 8px;\r\n  padding-top: 8px;\r\n}\r\n\r\n#period-form .row {\r\n  height: 30px;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.col {\r\n  /* Общие стили для колонок */\r\n}\r\n\r\n.col-fixed {\r\n  width: auto;\r\n  margin-right: 10px;\r\n}\r\n\r\n.col-flexible {\r\n  flex: 1;\r\n}\r\n\r\n.row {\r\n  margin-bottom: 12px;\r\n}\r\n\r\n/* Filter */\r\n.filter-container {\r\n  position: relative;\r\n  display: inline-block;\r\n  font-family: Arial, sans-serif;\r\n}\r\n\r\n.filter-icon {\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 0 2px;\r\n  width: 16px;\r\n  height: 16px;\r\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'%3E%3Cpath d='M8.4 10.7273L2 2H18L11.6 10.7273V18H8.4V10.7273Z' fill='%23999999'/%3E%3C/svg%3E\");\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.filter-dropdown {\r\n  position: absolute;\r\n  top: 100%;\r\n  right: 0%;\r\n  margin-top: 8px;\r\n  background: white;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n  padding: 12px;\r\n  width: 200px;\r\n  z-index: 10003000;\r\n  display: none;\r\n}\r\n\r\n.filter-dropdown.show {\r\n  display: block;\r\n}\r\n\r\n.filter-option {\r\n  display: flex;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.filter-option:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.filter-option label {\r\n  display: flex;\r\n  align-items: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.filter-option input {\r\n  margin-right: 8px;\r\n  width: 16px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
